import { Component, EventEmitter, OnChanges, Output, input, model, output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog'
import { Router } from '@angular/router';
import { ReportTypeModalComponent } from './report-type-modal/report-type-modal.component';
import { FullPhasedModalComponent } from './full-phased-modal/full-phased-modal.component';
import { FormBuilder } from '@angular/forms';
import { Subject } from 'rxjs/internal/Subject';
import { ReportService } from 'src/app/services/report.service';
import { ConfirmationToastComponent } from 'src/app/components/confirmation-toast/confirmation-toast.component';
import { faLock } from '@fortawesome/free-solid-svg-icons';
import { AutoSaveComponent } from '../auto-save/auto-save.component';

@Component({
    selector: 'app-report-type',
    templateUrl: './report-type.component.html',
    styleUrls: ['./report-type.component.scss'],
    standalone: false
})


export class ReportTypeComponent extends AutoSaveComponent implements OnChanges {
  faLock = faLock;

  report = input.required<any>();
  nav = model.required<string>();
  status = output<number | undefined>();
  @Output() loaded = new EventEmitter();
  errorList: string[] = [];
  saveSubject = new Subject<any>();

  partialSelection = false;

  form = this.formBuilder.group({
    report_type: [""],
    initial_report_type: [""],
  });

  constructor(
    public dialog: MatDialog,
    private readonly router: Router,
    private readonly formBuilder: FormBuilder,
    public readonly reportService: ReportService,
    public readonly toast: ConfirmationToastComponent,
  ) {
    super()
  }

  ngOnInit(): void {
    this.status.emit(undefined);
    if (this.report().report_num == 0) { //Pre-assessment
      this.form.patchValue({
        report_type: "Pre-assessment Request",
        initial_report_type: this.report().initial_report_type,
      })
      this.reportService.getReportList(this.report().assessment_id, '').subscribe({
        next: (data) => {
          let reports = data.reports;
          if (reports.length > 1) //more reports created
            this.form.disable();
          this.loaded.emit(true);
        }
      })
    } else if (this.report().report_num > 1 && this.report().geo_area_choice == "02") { //FULL to FULL
      this.form.patchValue({
        report_type: "Emergency Stabilization",
        initial_report_type: this.report().initial_report_type,
      })
      this.form.disable();
      this.loaded.emit(true);
    } else if (this.report().report_num == 1) { //INITIAL
      this.form.patchValue({
        report_type: this.report().report_type,
        initial_report_type: this.report().initial_report_type,
      })
      this.reportService.getReportList(this.report().assessment_id, '').subscribe({
        next: (data) => {
          let reports = data.reports.find((item:any) => item.report_num > 1);
          if (reports) //interim created, lock down selection
            this.form.disable();
          this.loaded.emit(true);
        }
      });

    } else { //prev was partial
      this.partialSelection = true;
      this.form.patchValue({
        initial_report_type: this.report().initial_report_type,
      })
      if ((this.report().initial_report_type ?? '') != '') //selection is already saved. lock down.
        this.form.disable();
      this.loaded.emit(true);
    }
    this.listenForChanges(this.form);
  }

  ngOnChanges(): void {
    if (this.nav() != '') this.navigate();
  }

  navigate() {
    this.save(true)
  }

  route() {
    switch (this.nav()) {
      case 'forward': {
        this.router.navigate(['/2500-8-report'], { queryParams: { report_id: this.report().report_id, report_page_input: 2 } });
        this.nav.set('');
        break;
      }
      case 'back': {
        this.router.navigate(['/2500-8-report'], { queryParams: { report_id: this.report().report_id, report_page_input: 1 } });
        this.nav.set('');
        break;
      }
      case 'close': {
        this.router.navigate(['fire-overview'], { queryParams: { assessment_id: this.report().assessment_id } });
        this.nav.set('');
        break;
      }
      default: {
        if (Number(this.nav()))
          this.router.navigate(['/2500-8-report'], { queryParams: { report_id: this.report().report_id, report_page_input: this.nav() } });
        this.nav.set('');
        break;
      }
    }
  }

  save_close() {
    if (!this.form.disabled) this.save();
    this.router.navigate(['fire-overview'], { queryParams: { assessment_id: this.report().assessment_id } });
  }

  reportTypeModal(event: any): void {
    event.stopPropagation();
    this.dialog.open(ReportTypeModalComponent, {
      width: "700px",
      panelClass: ['animate__animated', 'animate__fadeInDown'],
    })
  }

  fullVsPhasedModal(event: any): void {
    event.stopPropagation();
    this.dialog.open(FullPhasedModalComponent, {
      width: "540px",
      panelClass: ['animate__animated', 'animate__fadeInDown'],
    })
  }

  gatherData(): any {
    let data: any = {
      report_type: this.form.value.report_type ? this.form.value.report_type : undefined as string | undefined,
      initial_report_type: this.form.value.initial_report_type ? this.form.value.initial_report_type :  undefined as string | undefined,
    }
    let allFieldsFilled = true

    for (let field in this.form.controls) {
      if (this.form.get(field)?.value === null || this.form.get(field)?.value === "") {
        allFieldsFilled = false
      }
    }

    data.allFieldsFilled = allFieldsFilled
    return data
  }

  override save(navigate?: boolean) {
    this.navDebounceCheck(navigate)
    if (!this.form.dirty) {
      if (navigate) {
        this.route()
      }
      // Don't save if nothing has changed on autosave
      return
    }
    let data = this.gatherData();

    let report_num = undefined;
    if (data.report_type == "Pre-assessment Request" && this.report().report_num == 1) {
      report_num = 0
    } else if (data.report_type != "Pre-assessment Request" && this.report().report_num == 0) {
      report_num = 1
    }

    this.saveSubject.next(null)
    this.status.emit(data.allFieldsFilled ? 2 : 1);

    this.reportService.updateReport({
      report_id: this.report().report_id,

      report_type: data.report_type,
      initial_report_type: data.initial_report_type,
      report_num: report_num,

      page_1_status_id: data.allFieldsFilled ? 2 : 1,
    }).subscribe({
      next: (response) => {
        if (navigate) {
          if (this.nav() == "forward" && !data.allFieldsFilled) {
            this.form.markAllAsTouched();
            this.errorList = [];
            for (let field in this.form.controls) {
              const control = this.form.get(field);
              if (control?.invalid) {
                this.errorList.push(field.replaceAll('_', ' '));
              }
            }
            window.scrollTo({ top: 0, behavior: 'smooth' });
            this.nav.set('');
            this.postSave();
          } else
            this.route(); // navigate route after save because next page needs to see this page's changes
        } else {
          this.postSave();
        }
      },
      error: (response) => {
        this.toast.openErrorSnackBar(`There was an error saving the report`, "Please try again.");
      },
    })
  }
}
